import type { FlightSegment } from '../../types';
import { formatLocal } from '../../core';

/** 'LCA → EVN 27.12 11:55, Wizz Air' — для выбора парного рейса. */
export function flightLongLabel(f: FlightSegment): string {
  return `${f.from} → ${f.to} ${formatLocal(f.departLocal)}, ${f.carrier}`;
}

/** 'LCA → EVN 27.12, Wizz Air' — для выбора рейса у багажа. */
export function flightShortDateLabel(f: FlightSegment): string {
  const datePart = f.departLocal.slice(0, 10); // 'YYYY-MM-DD'
  const [, mm, dd] = datePart.split('-');
  const shortDate = dd && mm ? `${dd}.${mm}` : datePart;
  return `${f.from} → ${f.to} ${shortDate}, ${f.carrier}`;
}
